import { render } from "./AssignICD.vue?vue&type=template&id=6b1e5e72&ts=true"
import script from "./AssignICD.vue?vue&type=script&lang=ts"
export * from "./AssignICD.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__